// Real metal finish swatches sourced from the client's website.
// Files live in public/finishes/. Add more by dropping a file in there and adding an entry.
//
// Per-finish properties tune how the texture renders in 3D:
//   metalness: how reflective (0 = matte, 1 = mirror)
//   roughness: how blurred reflections are (0 = sharp, 1 = matte)
//   tint:      multiplier color over the texture (use #ffffff to keep the swatch's own colour)

const FINISH_LIBRARY = [
  {
    id: 'silver_lacquer',
    label: 'Silver Lacquer',
    url: '/finishes/silver_lacquer.jpg',
    metalness: 0.95,
    roughness: 0.28,
    tint: '#ffffff',
  },
  {
    id: 'chardonnay_lacquer',
    label: 'Chardonnay Lacquer',
    url: '/finishes/chardonnay_lacquer.jpg',
    metalness: 0.85,
    roughness: 0.32,
    tint: '#ffffff',
  },
  {
    id: 'champagne_lacquer',
    label: 'Champagne Lacquer',
    url: '/finishes/champagne_lacquer.jpg',
    metalness: 0.9,
    roughness: 0.3,
    tint: '#ffffff',
  },
  {
    id: 'gold_lacquer',
    label: 'Gold Lacquer',
    url: '/finishes/gold_lacquer.jpg',
    metalness: 1,
    roughness: 0.25,
    tint: '#ffffff',
  },
  {
    id: 'bronze_lacquer',
    label: 'Bronze Lacquer',
    url: '/finishes/bronze_lacquer.jpg',
    metalness: 1,
    roughness: 0.3,
    tint: '#ffffff',
  },
  {
    id: 'mahogany_lacquer',
    label: 'Mahogany Lacquer',
    url: '/finishes/mahogany_lacquer.webp',
    metalness: 0.75,
    roughness: 0.4,
    tint: '#ffffff',
  },
];

export default FINISH_LIBRARY;
